export const getDefaultCreateTenantConfigurationState = (state) => state.defaultCreateTenantConfiguration
